import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const inputCls = "w-full bg-slate-100 rounded-lg px-3.5 py-3 text-sm font-worksans outline-none focus:ring-2 focus:ring-[#A259FF]/40 transition-all";

export default function Register() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/";
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Passwort muss mind. 6 Zeichen haben");
      return;
    }
    setBusy(true);
    try {
      const u = await register(form);
      toast.success(`Willkommen bei dealzauber, ${u.name}! 🪄`);
      navigate(next);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Registrierung fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4 font-worksans" data-testid="register-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-6">
          <img src="/wizard-icon.png" alt="dealzauber" className="h-11 w-11 rounded-xl shadow-sm" />
          <span className="font-outfit font-extrabold text-xl tracking-tight">
            <span className="text-slate-900">deal</span><span className="ai-gradient-text">zauber</span>
          </span>
        </Link>
        <div className="bg-white rounded-2xl border border-slate-200 p-7 shadow-sm">
          <h1 className="font-outfit font-black text-2xl tracking-tight text-slate-900 mb-1">Konto erstellen</h1>
          <p className="text-sm text-slate-500 mb-6">Werde Teil der Deal-Community.</p>
          <form onSubmit={onSubmit} className="space-y-4">
            <input required value={form.name} onChange={set("name")} placeholder="Anzeigename" className={inputCls} data-testid="register-name" />
            <input type="email" required value={form.email} onChange={set("email")} placeholder="E-Mail" className={inputCls} data-testid="register-email" />
            <input type="password" required value={form.password} onChange={set("password")} placeholder="Passwort (mind. 6 Zeichen)" className={inputCls} data-testid="register-password" />
            <button type="submit" disabled={busy} className="w-full ai-gradient-bg text-white font-outfit font-bold rounded-xl px-6 py-3 hover:opacity-90 active:scale-95 transition-all inline-flex items-center justify-center gap-2" data-testid="register-submit">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Registrieren
            </button>
          </form>
          <p className="text-sm text-slate-500 text-center mt-5">
            Schon ein Konto? <Link to="/login" className="text-[#A259FF] font-semibold">Anmelden</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
